import { Router } from 'vue-router'
import { QRCODE_BARCODE_TYPE_REGEX } from '../constants'

export type RfidDataType = 'EPC' | 'URL' | 'UNKNOWN'

export interface RfidScanResult {
  epc: string
  rssi: string
}

export interface RfidScanParsedResult extends RfidScanResult {
  dataType: RfidDataType
  parsedValue: string
}

export function parseRfidScanResult(result: RfidScanResult): RfidScanParsedResult {
  const epcValue = result.epc.trim()

  const urlPattern = /^(https?:\/\/|tel:|mailto:|ftp:\/\/)/i
  if (urlPattern.test(epcValue)) {
    return {
      ...result,
      dataType: 'URL',
      parsedValue: epcValue,
    }
  }

  const epcPattern = /^[0-9A-Fa-f]+$/
  if (epcPattern.test(epcValue)) {
    return {
      ...result,
      dataType: 'EPC',
      parsedValue: epcValue,
    }
  }

  return {
    ...result,
    dataType: 'UNKNOWN',
    parsedValue: epcValue,
  }
}

export function moveToDetailPageWithScanResult(scanResults: RfidScanParsedResult[], router: Router) {
  if (scanResults.length !== 1) {
    return
  }
  const parsedValue = scanResults[0].parsedValue

  if (parsedValue.match(QRCODE_BARCODE_TYPE_REGEX)) {
    const urlParts = parsedValue.split('/')
    const barcodeId = urlParts[urlParts.length - 1].trim()
    const projectId = urlParts[urlParts.length - 3].trim()
    router.push({
      name: 'detail',
      params: {
        barcodeId: barcodeId,
        project: projectId,
      },
    })
  } else {
    const encodedValue = encodeURIComponent(parsedValue?.trim() || '')
    const projectCode = router.currentRoute?.value?.params?.project.split('@')
    if (projectCode && projectCode.length > 1) {
      projectCode.pop()
    }

    router.push({
      name: 'detail',
      params: { barcodeId: `projectCode=${projectCode[0]}` },
      query: { externalId: encodedValue, isGenerateBarcode: 1 },
    })
  }
}
